module.exports = __webpack_public_path__ + "static/134_1707210920-db8735af634c94095c14d6a8677f1162.mp4";